import React from "react";

const YearTotalProgress = (props) => {
    const { completed, total } = props;
  
    const containerStyles = {
        height: '25px',
        width: '50%',
        backgroundColor: "#e0e0de",
        margin: '0 auto',
        textAlign: 'center'
    }
  
    const fillerStyles = {
      height: '100%',
      width: `${completed}%`,
      transition: 'width 1s ease-in-out',
      backgroundColor: '#3ebd3e',
      textAlign: 'right'
    }
  
    const labelStyles = {
      padding: 5,
      color: 'white',
      fontWeight: 'bold'
    }
  
    return (
      <div style={containerStyles}>
        <div style={fillerStyles}>
          <span style={labelStyles}>{`${total}`}</span>
        </div>
      </div>
    );
  };
  
export default YearTotalProgress;